/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class PriceCalculationStrategyDto {
    id: string | null;
    name: string;
    price: number;
    calculation: string;
    noPriceText: string;
    sortOffset: number;
    groupOnIdenticalNameAndPriceOutcome: boolean;
    hideOnNoPrice: boolean;
}
